import { Directive, ElementRef } from '@angular/core';
import { Role } from '../../../types/shared/Role';
import { AuthService } from '../services/auth.service';
import { BaseRoleDirective } from './base-role.directive';

@Directive({
    selector: '[canToggleOnHold]',
    standalone: true
})
export class CanToggleOnHoldDirective extends BaseRoleDirective {

    constructor(private authServiceRef: AuthService, el: ElementRef) {
        super(authServiceRef, el);
        this.checkRole();
    }

    protected override checkRole(): boolean {
        return this.authServiceRef.hasAnyRole([
            Role.SAMPLE_STUDIO_ADMIN,
            Role.SAMPLE_STUDIO_MAINTAINER,
            Role.SAMPLE_STUDIO_PRODUCER,
            Role.SAMPLE_STUDIO_PROCESS_OWNER
        ]);
    }

}
